import { BaseAlgorithm } from './BaseAlgorithm';
import { CIDS } from '../../components/ProductsTable/constants';
import { debugLog, rankDebugLogEnable } from './ranking';

export class LevelTranslatorAlgorithm extends BaseAlgorithm {
	constructor(usedFilters, filtersState) {
		super(usedFilters, filtersState);
		this.usedFilters = usedFilters;

		this.normVccaMin = 1.5;
		this.normVccaMax = 5;
		this.normVccbMin = 1.5;
		this.normVccbMax = 3;
		this.normTpdMax = 3;
		this.normIoMax = 10;

		this.rankVccaMin = 0;
		this.rankVccaMax = 0;
		this.rankVccbMin = 0;
		this.rankVccbMax = 0;
		this.rankTpdMax = 0;
		this.rankIoMax = 0;

		this.weightVccaMin = 0.05;
		this.weightVccaMax = 0.05;
		this.weightVccbMin = 0.05;
		this.weightVccbMax = 0.05;
		this.weightTpdMax = 0.2;
		this.weightIoMax = 0.1;

		this.rVccaMin = 0;
		this.rVccaMax = 0;
		this.rVccbMin = 0;
		this.rVccbMax = 0;
		this.rTpdMax = 0;
		this.rIoMax = 0;
	}

	logHeadingsToConsole() {
		if (rankDebugLogEnable) {
			console.log(
				'partNumber,' +
					'part_VccaMin,rVccaMin,rankVccaMin,' +
					'part_VccaMax,rVccaMax,rankVccaMax,' +
					'part_VccbMin,rVccbMin,rankVccbMin,' +
					'part_VccbMax,rVccbMax,rankVccbMax,' +
					'part_TpdMax,rTpdMax,rankTpdMax,' +
					'part_IoMax,rIoMax,rankIoMax,' +
					'feRank'
			);
		}
	}

	execute(product) {
		debugLog.length = 0;
		debugLog.push(product[CIDS.PART_NUMBER]);

		// ---------------------------------------------Supply voltage  VCCA Min (V)---------------------------------------------
		[this.rankVccaMin, this.rVccaMin] = this.calculateRankSingleSliderLTE(CIDS.V_CCA_MIN, product, this.normVccaMin);

		// ---------------------------------------------Supply voltage  VCCA Max (V)---------------------------------------------
		[this.rankVccaMax, this.rVccaMax] = this.calculateRankSingleSliderGTE(CIDS.V_CCA_MAX, product, this.normVccaMax);

		// ---------------------------------------------Supply voltage  VCCB Min (V)---------------------------------------------
		[this.rankVccbMin, this.rVccbMin] = this.calculateRankSingleSliderLTE(CIDS.V_CCB_MIN, product, this.normVccbMin);

		// ---------------------------------------------Supply voltage  VCCB Max (V)---------------------------------------------
		[this.rankVccbMax, this.rVccbMax] = this.calculateRankSingleSliderGTE(CIDS.V_CCB_MAX, product, this.normVccbMax);

		// ---------------------------------------------Propagation delay  tpd Max (ns)---------------------------------------------
		[this.rankTpdMax, this.rTpdMax] = this.calculateRankSingleSliderLTE(CIDS.T_PD_MAX, product, this.normTpdMax);

		// ---------------------------------------------Output Current  IO Max (mA)---------------------------------------------
		[this.rankIoMax, this.rIoMax] = this.calculateRankSingleSliderGTE(CIDS.I_O_MAX, product, this.normIoMax);

		// -------------------------------------------------------------------------------------------

		let feRank =
			this.weightVccaMin * this.rankVccaMin +
			this.weightVccaMax * this.rankVccaMax +
			this.weightVccbMin * this.rankVccbMin +
			this.weightVccbMax * this.rankVccbMax +
			this.weightTpdMax * this.rankTpdMax +
			this.weightIoMax * this.rankIoMax;
		let isPunished = false;
		debugLog.push(feRank);

		[feRank, isPunished] = super.punishPartsWithNullValueOfUsedFilters(product, this.usedFilters, feRank);

		let finalRank =
			(1 -
				this.weightVccaMin -
				this.weightVccaMax -
				this.weightVccbMin -
				this.weightVccbMax -
				this.weightTpdMax -
				this.weightIoMax) *
				super.execute(product) +
			feRank;

		return isPunished ? finalRank / this.maxRankAfterPunish : finalRank;
	}
}
